import { render, staticRenderFns } from "./BrickTimerScheduleOnceSettings.vue?vue&type=template&id=4c65fd7c&"
import script from "./BrickTimerScheduleOnceSettings.vue?vue&type=script&lang=js&"
export * from "./BrickTimerScheduleOnceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c65fd7c')) {
      api.createRecord('4c65fd7c', component.options)
    } else {
      api.reload('4c65fd7c', component.options)
    }
    module.hot.accept("./BrickTimerScheduleOnceSettings.vue?vue&type=template&id=4c65fd7c&", function () {
      api.rerender('4c65fd7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Connection/BrickTimerScheduleOnceSettings.vue"
export default component.exports